/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./retain-capital.vue?vue&type=template&id=32dacef4&"
import script from "./retain-capital.vue?vue&type=script&lang=js&"
export * from "./retain-capital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports